import { isAvailable, FDealType, FOfferType, isAvailableStrict } from '../../../../../JsonQuery';

export const OLD_DESIGN_FILTERS = [
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Flat),
    list: [
      'specialOffers',
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'squareMeterArea',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      // Серия дома
      'demolition',
      'elevators',
      // Пандус
      'parking',
      'saleType',
      'apartments',
      'flatShare',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailableStrict(FDealType.Sale, FOfferType.House),
    list: [
      'suburbanHouseType',
      'withNeighbors',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'constructionType',
      'heatingType',
      'suburbanUtilities',
      'suburbanFacilities',
      'landStatus',
      'floors',
      'bedrooms',
      'suburbanBathroom',
      'constructionYear',
      'possessor',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.House | FOfferType.HousePart | FOfferType.Townhouse),
    list: [
      'withNeighbors',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'constructionType',
      'heatingType',
      'suburbanUtilities',
      'landStatus',
      'floors',
      'bedrooms',
      'suburbanBathroom',
      'constructionYear',
      'suburbanFacilities',
      'possessor',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Land),
    list: [
      'withNeighbors',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'suburbanUtilities',
      'landStatus',
      'possessor',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];

export const REDESIGN_FILTERS = [
  // Новостройки + Вторичка
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Flat),
    list: [
      'specialOffers',
      'withNeighbors',
      'undergroundTimeNew',
      'squareMeterArea',
      'floor',
      'floors',
      'furniture',
      'repair',
      'constructionYear',
      'constructionType',
      'demolition',
      'balcony',
      'elevators',
      'kitchenStove',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'windows',
      'apartments',
      'parking',
      'offerSeller',
      'saleType',
      'flatShare',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },

  // Загородка
  {
    availability: isAvailableStrict(FDealType.Sale, FOfferType.House),
    list: [
      'withNeighbors',
      'fromMKAD',
      'undergroundTimeNew',
      'landStatus',
      'constructionType',
      'suburbanHouseType',
      'suburbanBathroom',
      'suburbanUtilities',
      'heatingType',
      'suburbanFloors',
      'bedroomsNew',
      'constructionYear',
      'suburbanFacilities',
      'offerSeller',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.House | FOfferType.HousePart | FOfferType.Townhouse),
    list: [
      'withNeighbors',
      'fromMKAD',
      'undergroundTimeNew',
      'landStatus',
      'constructionType',
      'suburbanHouseType',
      'suburbanBathroom',
      'suburbanUtilities',
      'heatingType',
      'suburbanFloors',
      'bedroomsNew',
      'constructionYear',
      'suburbanFacilities',
      'offerSeller',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Land),
    list: [
      'withNeighbors',
      'fromMKAD',
      'undergroundTimeNew',
      'landStatus',
      'suburbanUtilities',
      'offerSeller',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];
